<template>
  <div class="flex items-center pb-0.5">
    <label
      v-if="side === 'left'"
      class="text-15 tracking-wide font-bold text-center w-7 mr-3"
      :for="uid"
    >
      {{ displayScore }}
    </label>

    <meter
      :id="uid"
      :value="(score || 0) * 10"
      :class="[
        `text-score-${getScoreLabel(score)}`,
        {
          'rounded-right rotate-180': side === 'left',
          'rounded-right': side === 'right',
          'rounded-all': side === 'center',
        },
      ]"
      class="w-full bg-none bg-gray-200 h-2"
      min="0"
      max="100"
    />

    <label
      v-if="side !== 'left'"
      class="text-15 tracking-wide font-bold text-center w-7 ml-3"
      :for="uid"
    >
      {{ displayScore }}
    </label>
  </div>
</template>

<script lang="ts" setup>
const uid = useId()

const props = withDefaults(
  defineProps<{
    score: number | undefined
    side?: 'left' | 'right' | 'center'
  }>(),
  { side: 'center' },
)

const { $lang } = useNuxtApp()

const displayScore = computed(() => {
  if (props.score === 10) {
    return String(props.score)
  } else if (typeof props.score === 'number') {
    return formatNumber(props.score, $lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
  }
  return '-'
})
</script>

<style scoped>
.rounded-right,
.rounded-right::-webkit-meter-bar,
.rounded-right::-webkit-meter-optimum-value {
  @apply rounded-none rounded-r-10;
}
/* Has to be a separate rule for Firefox */
.rounded-right::-moz-meter-bar {
  @apply rounded-none rounded-r-10;
}

.rounded-all,
.rounded-all::-webkit-meter-bar,
.rounded-all::-webkit-meter-optimum-value {
  @apply rounded-10;
}
/* Has to be a separate rule for Firefox */
.rounded-all::-moz-meter-bar {
  @apply rounded-10;
}

meter::-webkit-meter-inner-element {
  @apply flex;
}

meter::-webkit-meter-bar {
  @apply bg-none bg-gray-200 border-0 overflow-visible w-full;
}

meter::-webkit-meter-optimum-value {
  @apply bg-none bg-current h-2;
}

meter::-moz-meter-bar {
  @apply bg-none bg-current;
}
</style>
